import { render, staticRenderFns } from "./masterpaketislem.vue?vue&type=template&id=4d06e4c9&"
import script from "./masterpaketislem.vue?vue&type=script&lang=js&"
export * from "./masterpaketislem.vue?vue&type=script&lang=js&"
import style0 from "./masterpaketislem.vue?vue&type=style&index=0&id=4d06e4c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports